import { render, staticRenderFns } from "./EmployeeSalaryForm.vue?vue&type=template&id=b13d374a"
import script from "./EmployeeSalaryForm.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports